import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[arabicToEnglish]'
})
export class ArabicToEnglishDirective {
  private easternToWesternMap: { [key: string]: string } = {
    '٠': '0',
    '١': '1',
    '٢': '2',
    '٣': '3',
    '٤': '4',
    '٥': '5',
    '٦': '6',
    '٧': '7',
    '٨': '8',
    '٩': '9'
  };

  constructor(private el: ElementRef<HTMLInputElement>) { }

  // Convert during typing or programmatic changes
  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = this.el.nativeElement;
    const originalValue = input.value;
    const convertedValue = this.convertArabicToEnglish(originalValue);

    if (originalValue !== convertedValue) {
      input.value = convertedValue;

      // Dispatch input event to update Angular forms
      const newEvent = new Event('input', { bubbles: true });
      input.dispatchEvent(newEvent);
    }
  }

  // Convert on paste before it goes into the field
  @HostListener('paste', ['$event'])
onPaste(event: ClipboardEvent) {
  event.preventDefault();
  const clipboardData = event.clipboardData?.getData('text') || '';
  const converted = this.convertArabicToEnglish(clipboardData);

  const input = this.el.nativeElement;
  const maxLength = input.maxLength > 0 ? input.maxLength : Infinity;

  const start = input.selectionStart || 0;
  const end = input.selectionEnd || 0;

  const currentValue = input.value;
  const newValue =
    currentValue.substring(0, start) +
    converted +
    currentValue.substring(end);

  // Enforce maxLength
  const trimmedValue = newValue.slice(0, maxLength);

  input.value = trimmedValue;

  // Move cursor after inserted text (clamped to maxLength)
  const cursorPos = Math.min(start + converted.length, maxLength);
  input.setSelectionRange(cursorPos, cursorPos);

  // Trigger input event to update Angular forms
  const newEvent = new Event('input', { bubbles: true });
  input.dispatchEvent(newEvent);
}


  private convertArabicToEnglish(input: string): string {
    return input.replace(/[٠-٩]/g, (d) => this.easternToWesternMap[d]);
  }
}
